import { Dialog, Button, DialogTitle, DialogContentText, DialogActions, DialogContent } from '@mui/material';
import { toTitleCase } from '../../../utils';
import { useContent } from '../../../logic'

interface CompletePayloadTaskDialogProps {
    open: boolean;
    setUserCompleteOpen: (open: boolean) => void;
    onUserCompleteTask: () => void;
}

export function CompletePayloadTaskNoAmountSpecified({ open, setUserCompleteOpen, onUserCompleteTask }: CompletePayloadTaskDialogProps) {

  const { TaskText } = useContent()

  return <Dialog key="userComplete" open={open}>
    <DialogTitle>Complete {toTitleCase(TaskText)}</DialogTitle>

    <DialogContent>
      <DialogContentText sx={{ mb: 1 }}>Mark this {TaskText} as complete?</DialogContentText>
      <DialogContentText>This confirms that all required payments have been made. You will not be able to submit more payments through this {TaskText} once it's completed.</DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button variant="rounded" onClick={() => setUserCompleteOpen(false)}>
                Not yet
      </Button>
      <Button variant="contained" onClick={onUserCompleteTask}>
                Yes, complete it
      </Button>
    </DialogActions>
  </Dialog>
}
